import routes from '@routes/config';

export default [{
    path: routes.proformaBill.index,
    name: routes.proformaBill.index,
    component: () => import(/* webpackChunkName: "ProformaBill" */  '@components/ProformaBill/Index')
}]
            